import AppointmentsModal from './AppointmentsModal';

export default AppointmentsModal;
